import { ButtonLink, Icon, IconComponentType, Surface, Txt } from '@vst/beam';

import { useScreenResolution } from '@app/hooks';

import styles from '../styles.module.scss';

type NetworkManagementCardProps = {
  icon: IconComponentType;
  title: string;
  buttonLabel?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  testId?: string;
  loading?: boolean;
};

export const NetworkManagementCard = ({
  icon,
  title,
  buttonLabel,
  onClick,
  testId = 'network-management-link',
  loading = false,
}: NetworkManagementCardProps) => {
  const { isExtraLarge, isLarge, isMedium } = useScreenResolution();
  const isDesktop = isExtraLarge || isLarge || isMedium;

  if (loading) {
    return (
      <Surface radius={isDesktop ? '16px' : '0px'} p="24px" className={styles['helpCardContainer']}>
        <div className={styles['iconLoading']} />

        <div className={styles['helpCardTextLink']}>
          <div className={styles['titleLoading']} />
          <div className={styles['buttonLoading']} />
        </div>
      </Surface>
    );
  }

  return (
    <Surface radius={isDesktop ? '16px' : '0px'} p="24px" className={styles['helpCardContainer']}>
      <Icon icon={icon} size={40} color="gray_600" data-cy="network-management-icon" />

      <div className={styles['helpCardTextLink']}>
        <Txt variant={'bodyLargeRegular'} color={'subtle'}>
          {title}
        </Txt>

        {buttonLabel && onClick ? (
          <ButtonLink
            variant={'primary'}
            href=""
            onClick={onClick}
            label={buttonLabel}
            linkSize={'medium'}
            data-cy={testId}
          />
        ) : null}
      </div>
    </Surface>
  );
};
